var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "search-result-list",
        attrs: { id: "search-result-list" },
      },
      [
        this.$props.computedListView
          ? _c(
              "ul",
              {
                staticClass: "search-result-list-items",
                attrs: { id: "search-result-list-items" },
              },
              _vm._l(_vm.rows, function (e, i) {
                return _c("search-result-list-item", {
                  key: i,
                  attrs: { index: i, elementInfo: e },
                })
              }),
              1
            )
          : _c(
              "table",
              { staticClass: "search-result-table-items" },
              [
                _vm._m(0),
                _vm._v(" "),
                _vm._l(_vm.rows, function (e, i) {
                  return _c("search-result-list-table-item", {
                    key: i,
                    attrs: { index: i, elementInfo: e },
                  })
                }),
              ],
              2
            ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", { attrs: { width: "1%" } }, [
        _c("i", {
          staticClass: "lnr lnr-apartment",
          staticStyle: { color: "rgb(89, 171, 227)" },
        }),
      ]),
      _vm._v(" "),
      _c("th", { attrs: { width: "1%" } }, [_vm._v(" ")]),
      _vm._v(" "),
      _c("th", { attrs: { width: "1%" } }, [_vm._v(" ")]),
      _vm._v(" "),
      _c("th", { attrs: { width: "1%" } }, [_vm._v("ОГРН")]),
      _vm._v(" "),
      _c("th", [_vm._v("Наименование")]),
      _vm._v(" "),
      _c("th", { attrs: { width: "1%" } }, [_vm._v("Регистрация")]),
      _vm._v(" "),
      _c("th", { attrs: { width: "1%" } }, [_vm._v("Коды")]),
      _vm._v(" "),
      _c("th", [_vm._v("Деятельность")]),
      _vm._v(" "),
      _c("th", [_vm._v("Руководитель")]),
      _vm._v(" "),
      _c("th", [
        _c("b", [_vm._v("Контакты")]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("span", [_vm._v("Показаны первые 3")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }